module.exports = "<p>\r\n  modal-cambiar-nota works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/modal-cambiar-nota/modal-cambiar-nota.component.html
// module id = ./src/app/shared/modal/modal-cambiar-nota/modal-cambiar-nota.component.html
// module chunks = main